import logo from '../../assets/images/ascasSVG.svg';
import './headers.scss';
const Headers = () => {
  let date = new Date();
  let todayDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  return (
    <div className='mainHeader'>
      <div className='HeaderContainer'>
        <div className='imgContainer'>
          <img src={logo} alt='' />
        </div>
        <div>
          <div className='locationContainer'>
            <p>ASCAS Fertility and Women's Centre</p>
          </div>
        </div>
      </div>

      <div style={{textAlign: 'right'}}>
        <section>
          <label style={{fontSize: '14px', fontWeight: '600'}}>Visit Date :</label>
          <span> {todayDate}</span>
        </section>
      </div>
    </div>
  );
};

export default Headers;
